
<div>
  <input
    type="text"
    class="form-control"
    placeholder="Search by book title..."
    (input)="updateFilter($event)"
  />
</div>
<ngx-datatable
class="bootstrap"
[rows]="books"
[columnMode]="'force'"
[headerHeight]="50"
[footerHeight]="50"
[rowHeight]="'auto'"
[limit]="10"
[loadingIndicator]="loadingIndicator"
[reorderable]="reorderable"
>
<ngx-datatable-column>
  <ng-template ngx-datatable-cell-template let-row="row">
    <div [style.background-color]="getRandomColor()" 
         style="width: 50px; height: 50px; display: flex; align-items: center; justify-content: center; border-radius: 50%; color: white; font-weight: bold;">
      {{ row.title ? row.title.charAt(0).toUpperCase() : '' }}
    </div>
  </ng-template>
</ngx-datatable-column>
<ngx-datatable-column name="Title" prop="title" ><ng-template ngx-datatable-cell-template let-row="row"><span style="color: blue;">{{row.title}}</span></ng-template></ngx-datatable-column>
<ngx-datatable-column name="ISBN" prop="isbn" ><ng-template ngx-datatable-cell-template let-row="row"><span style="color: red;">{{row.isbn}}</span></ng-template></ngx-datatable-column>
<ngx-datatable-column name="Writer" prop="writer.name"></ngx-datatable-column>
<ngx-datatable-column name="Publisher" prop="publisher.name"></ngx-datatable-column>
<ngx-datatable-column name="Edition" prop="edition"></ngx-datatable-column>
<ngx-datatable-column name="Category" prop="category.category_name"></ngx-datatable-column>
<ngx-datatable-column name="Actions">
  <ng-template ngx-datatable-cell-template let-row="row">
    <button class="btn btn-outline-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      Actions
    </button>
    <div style="z-index: 99999999;" class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <a class="dropdown-item" (click)="openViewDialog(row)"><i class="fas fa-eye"></i> View</a>
      <a class="dropdown-item" (click)="openCheckinDialog(row)"><i class="fas fa-calendar-check"></i> Check-in</a>
      <a class="dropdown-item" (click)="openCheckoutDialog(row)"><i class="fas fa-calendar-times"></i> Check-out</a>
      <a class="dropdown-item" (click)="openEditDialog(row)"><i class="fas fa-edit"></i> Edit</a>
      <a class="dropdown-item" (click)="openQRCodeViewDialog(row)"><i class="fas fa-barcode"></i> Generate Bar code</a>
      <a class="dropdown-item" (click)="openBarCodeViewDialog(row)"><i class="fas fa-qrcode"></i> Generate QR code</a>
      <a class="dropdown-item" (click)="delete(row.id)"><i class="fas fa-trash"></i> Delete</a>
      <a class="dropdown-item" (click)="duplicate(row)"><i class="fas fa-clone"></i> Duplicate</a>
      <a class="dropdown-item" (click)="openChangeCoverDialog(row)"><i class="fas fa-image"></i> Change Cover Photo</a>
      <a class="dropdown-item" (click)="archiveBook(row.id)"><i class="fas fa-archive"></i> Archive</a>
      <a class="dropdown-item" (click)="destroyBook(row.id)"><i class="fas fa-trash-alt"></i> Destroy</a>
      <a class="dropdown-item" (click)="openOnHoldDialog(row)"><i class="fas fa-bookmark"></i> Place Hold</a>
    </div>
  </ng-template>
</ngx-datatable-column> 
</ngx-datatable>